<script lang="ts">
    type coordinatesType = {
        x: number
        y: number
    }
    export let content: string;
    export let coordinates : coordinatesType;
    export let handleClick: Function;
</script>
<div class="circle-item" style={`left: ${coordinates.x}px; top: ${coordinates.y}px`} on:click={() => handleClick()}>
    {content}
</div>
<style>
    .circle-item {
        position: absolute;
        box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
        width: 190px;
        height: 190px;
        border-radius: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #fff;
        padding: 10px;
        text-align: center;
        font-weight: 600;
        cursor: pointer;
    }
    .circle-item:hover {
        box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;
    }
    @media (max-width: 1300px) {
        .circle-item {
            width: 140px;
            height: 140px;
        }
    }
    @media (max-width: 500px) {
        .circle-item {
            width: 100px;
            height: 100px;
            font-size: 12px;
        }
    }
</style>